import VanillaLazyLoad from 'vanilla-lazyload/dist/lazyload.min';

// Export
export default class LazyLoad {
  constructor(options = {}, elementsToLazyLoad = undefined) {
    this.ready = import(/* webpackChunkName: "intersectionObserverPolyfill" */ '../intersection-observer/polyfill')
      .then(async (polyfillPromise) => {
        await polyfillPromise;
        this.lazyLoad = new VanillaLazyLoad(Object.assign({
          data_src: 'lazysrc',
          data_srcset: 'lazysrcset',
          data_sizes: 'lazysizes',
          elements_selector: '.lazy',
          use_native: true,
        }, options), elementsToLazyLoad);
      });
  }

  load(el, force) {
    this.lazyLoad.load(el, force);
  }

  destroy() {
    this.lazyLoad.destroy();
  }

  update(elementsToLazyLoad) {
    this.lazyLoad.update(this._toArray(elementsToLazyLoad));
  }

  unsubscribe(nodes) {
    this._toArray(nodes).forEach(node => this.lazyLoad._observer.unobserve(node));
  }

  _toArray(nodes) {
    if (Array.isArray(nodes)) return nodes;

    if (nodes instanceof NodeList) return [].slice.call(nodes);

    if (nodes instanceof HTMLElement) return [nodes];

    return [];
  }
}
